export const numericKeys = {
  KEY_ZERO: 'zero',
  KEY_ONE: 'one',
  KEY_TWO: 'two',
  KEY_THREE: 'three',
  KEY_FOUR: 'four',
  KEY_FIVE: 'five',
  KEY_SIX: 'six',
  KEY_SEVEN: 'seven',
  KEY_EIGHT: 'eight',
  KEY_NINE: 'nine',
};

export const actionsKeys = {
  KEY_SPACE: 'space',
  KEY_UP: 'up',
  KEY_DOWN: 'down',
  KEY_RIGHT: 'right',
  KEY_LEFT: 'left',
  KEY_ENTER: 'enter',
  KEY_RED: 'red',
  KEY_GREEN: 'green',
  KEY_YELLOW: 'yellow',
  KEY_BLUE: 'blue',
  KEY_PLAY: 'play',
  KEY_PAUSE: 'pause',
  KEY_BACK: 'back',
  KEY_REWIND: 'rewind',
  KEY_FASTFORWARD: 'fastForward',
  KEY_STOP: 'stop',
  KEY_REWIND_LONGPRESS: 'rewindLongPress',
  KEY_FASTFORWARD_LONGPRESS: 'fastForwardLongPress',
  KEY_SKIP_REWIND: 'skipRewind',
  KEY_SKIP_FASTFORWARD: 'skipFastForward',
  KEY_PLAY_PAUSE: 'playPause',
  KEY_DONE: 'done',
};

export const numbers = {
  [numericKeys.KEY_ZERO]: 0,
  [numericKeys.KEY_ONE]: 1,
  [numericKeys.KEY_TWO]: 2,
  [numericKeys.KEY_THREE]: 3,
  [numericKeys.KEY_FOUR]: 4,
  [numericKeys.KEY_FIVE]: 5,
  [numericKeys.KEY_SIX]: 6,
  [numericKeys.KEY_SEVEN]: 7,
  [numericKeys.KEY_EIGHT]: 8,
  [numericKeys.KEY_NINE]: 9,
};
